import { LocalizationProvider as MuiLocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import th from 'dayjs/locale/th';
import dayjs from 'dayjs';
import BuddhistAdapter from './buddhist-era-adapter';

dayjs.locale('th');

type Props = {
  children: React.ReactNode;
};

export default function LocalizationProvider({ children }: Props) {
  return (
    <MuiLocalizationProvider dateAdapter={BuddhistAdapter} adapterLocale={th as any}>
      {children}
    </MuiLocalizationProvider>
  );
}
